import { Injectable } from "@angular/core";
import { AppState } from "../../app.service";

@Injectable()
export class TTLCacheService {

  constructor(private appState:AppState) {
    this.appState.notification$.subscribe((data: any) => {
      if(data.nType === 1 && data.Data.action === 'clear-cache'){
        for (let i = localStorage.length - 1; i >= 0; i--) {
          const key = localStorage.key(i);
          if (key && key.startsWith(data.Data.key)) {
              localStorage.removeItem(key);
          }
        }
      }
    });
  }

  set(key: string, data: any, ttlMinutes: number): void {
    const expires = new Date().getTime() + ttlMinutes * 60 * 1000;
    const payload = { data, expires };
    localStorage.setItem(key, JSON.stringify(payload));
  }

  get<T>(key: string): T | null {
    const cached = localStorage.getItem(key);
    if (!cached) return null;

    const parsed = JSON.parse(cached);
    const now = new Date().getTime();

    if (parsed.expires < now) {
      localStorage.removeItem(key); // expired
      return null;
    }

    return parsed.data as T;
  }

  clear(key: string): void {
    localStorage.removeItem(key);
  }

  clearAll(): void {
    localStorage.clear();
  }
}
